import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import Sidebar from "./components/Sidebar";
import UploadModule from "./modules/UploadModule";
import BrokerTagging from "./modules/BrokerTagging";
import SignalsModule from "./modules/SignalsModule";
import StockDetail from "./modules/StockDetail";
import InstitutionalFlow from "./modules/InstitutionalFlow";
import SimulatorModule from "./modules/SimulatorModule";
import RealTradesModule from "./modules/RealTradesModule";
import ComparisonModule from "./modules/ComparisonModule";
import SettingsModule from "./modules/SettingsModule";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <div className="app-container bg-trading-bg text-trading-text" data-testid="app-root">
          <Sidebar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Navigate to="/signals" replace />} />
              <Route path="/signals" element={<SignalsModule />} />
              <Route path="/flow" element={<InstitutionalFlow />} />
              <Route path="/upload" element={<UploadModule />} />
              <Route path="/broker-tags" element={<BrokerTagging />} />
              <Route path="/stock/:symbol" element={<StockDetail />} />
              <Route path="/simulator" element={<SimulatorModule />} />
              <Route path="/trades" element={<RealTradesModule />} />
              <Route path="/comparison" element={<ComparisonModule />} />
              <Route path="/settings" element={<SettingsModule />} />
              <Route path="*" element={<Navigate to="/signals" replace />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
